import * as tslib_1 from "tslib";
import CreateStaffSelector from "../../../../../form/src/common/components/createStaffSelector.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
let OwnerId = class OwnerId extends Vue {
    render(h) {
        return h('create-staff-selector', { props: { opts: { disabled: true }
            } });
    }
};
tslib_1.__decorate([
    Prop()
], OwnerId.prototype, "control", void 0);
OwnerId = tslib_1.__decorate([
    Component({
        name: 'OwnerId',
        components: {
            CreateStaffSelector
        }
    })
], OwnerId);
export default OwnerId;
